import Http from "@/commons/Http";

const path = '/api/anexo';

export default {

  /**
   * Envia uma imagem anexada num editor de texto e devolve a URL relativa à raiz que fica no src.
   *
   * O `referencia` é o dono do texto, quando a tela souber informar. Sem ele a imagem funciona e é
   * deduplicada do mesmo jeito; perde-se apenas o vínculo de rastreabilidade.
   */
  async upload(blob, nome, referencia) {

    const formData = new FormData();
    formData.append("file", blob, nome || 'imagem.png');

    return Http.post(`${path}/imagem-texto${referencia ? `?referencia=${referencia}` : ''}`, formData, {
      timeout: 0,
      headers: {'Content-Type': 'multipart/form-data'}
    });
  }

}
